import { render, staticRenderFns } from "./TelegramGroupFormModal.vue?vue&type=template&id=587b7fd7&scoped=true&"
import script from "./TelegramGroupFormModal.vue?vue&type=script&lang=js&"
export * from "./TelegramGroupFormModal.vue?vue&type=script&lang=js&"
import style0 from "./TelegramGroupFormModal.vue?vue&type=style&index=0&id=587b7fd7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587b7fd7",
  null
  
)

export default component.exports